import { defaultApiBuilder, defaultApiWithCustomUrlBuilder } from "../utils/axios/apiBuilder";
import { basename } from "../utils/Url";
import { parseJSON } from "../utils/date";
import Cookies from "js-cookie";

const apiPendencies = defaultApiBuilder(parseJSON);
const apiPendenciesWithCustomUrl = defaultApiWithCustomUrlBuilder(parseJSON);

export const AxiosPendencyAPI = {
  getAll: async (
    { pending = "", cancelable = "", resolvable = "", page = 1 },
    { signal }
  ) => {
    const params = {
      page
    };
    if (pending) params.pending = pending;
    if (cancelable) params.cancelable = cancelable;
    if (resolvable) params.resolvable = resolvable;

    const response = await apiPendencies.get(
      `/managerchangerequests/`,
      { params, signal }
    );
    return response.data;
  },
  accept: async ([{ pendency_url }], props, { signal }) => {
    const response = await apiPendenciesWithCustomUrl.post(
      `${pendency_url}accept/`,
      { signal }
    );
    return response.data;
  },
  reject: async ([{ pendency_url, reason = "" }], props, { signal }) => {
    const response = await apiPendenciesWithCustomUrl.post(
      `${pendency_url}reject/`,
      { reason },
      { signal }
    );
    return response.data;
  },
  cancel: async ([{ pendency_url }], props, { signal }) => {
    const response = await apiPendenciesWithCustomUrl.post(
      `${pendency_url}cancel/`,
      { signal }
    );
    return response.data;
  },
}